import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, ViewEncapsulation, Injector, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, ProjectStatus, ProjectSystemStatus } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import * as Enumerable from 'linq';
import { Observable, of, tap } from 'rxjs';

@Component({
    selector: 'project-status-picker',
    templateUrl: './project.status.picker.component.html',
    styleUrls: ['./project.status.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
        PickerItemModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ProjectStatusPickerComponent),
            multi: true
        }
    ]
})
export class ProjectStatusPickerComponent extends PickerBaseComponent implements OnChanges {

    @Input() public data: ProjectStatus[];
    @Input() public placeholder = '<Project Status>';
    @Input() public multiple = false;
    @Input() public allowClear = false;
    @Input() public appendTo;
    @Input() public selectableGroup = false;
    @Input() public allowClose = true;

    public data$: Observable<ProjectStatus[]>;
    public PickerItemStyle = PickerItemStyle;

    constructor(
        cdr: ChangeDetectorRef,
        injector: Injector,
        private http: HttpClient
    ) {
        super(injector);
    }

    public ngOnChanges() {

        this.data$ = this.fetch === PickerFetch.Automatic
            ? this.getLabels()
            : of(this.data);

    }

    private getLabels(): Observable<ProjectStatus[]> {
        return this.http.get<ProjectStatus[]>(`/api/projects/statuses`)
            .pipe(
                tap(stages => {

                    const openStages = Enumerable
                        .from(stages)
                        .where(x => x.systemStatus === ProjectSystemStatus.Open)
                        .toArray();


                    const closedStages = this.allowClose
                        ? Enumerable
                            .from(stages)
                            .where(x => x.systemStatus === ProjectSystemStatus.Closed)
                            .toArray()
                        : [];

                    return [...openStages, ...closedStages];

                })
            );
    }


    public compareFn(data1: Entity, data2: Entity): Boolean {
        // data will included category & subcategory
        if (!data1?._id || !data2?._id) {
            return false;
        }

        const same = data1?._id === data2?._id;
        return same;
    }


    public getGroup(groupKey: string, children: any[]) {

        const group = {
            _id: groupKey,
            name: `${groupKey}: All`,
            systemStage: groupKey,
            systemGroup: true
        }

        return group;
    }

}
